module.exports = __webpack_public_path__ + "static/media/intro6.07ac90fe.png";